import './Login.sass'

const Login = () => {
  return (
    <div className='login'>Login</div>
  )
}

export default Login